<app-billing-header></app-billing-header>
<div class="content">
    <h2 class="mat-dialog-title custom-billing-heading">Payment Methods</h2>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <div *ngIf="!loading" class="payment-methods-row" >
        <div *ngFor="let method of paymentMethods" class="payment-methods-item" >
            <mat-card class="payment-card selected">
                <div class="card-header mat-elevation-z0">
                    <h4 class="card-title" style="text-transform: capitalize; color: black;">
                        {{method.details.card.brand}}
                    </h4>
                    <button class="save" mat-flat-button (click)="cardDefault(method)"
                        [ngStyle]="{ 'background-color': 'var(--primary-color)', 'color': 'var(--light-color)' }"
                         type="submit" [disabled]="processing || method.default_method === 1"
                        [ngClass]="method.default_method === 1 ? 'primary-card' : ''">
                        <mat-icon *ngIf="processing">
                            <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                        </mat-icon>
                        {{ method.default_method === 1 ? 'Primary' : 'Set Primary' }}
                    </button>
                </div>
                <div class="card-content">
                    <img class="card-logo"
                        [src]="getCardIcon(method.details.card.brand )"
                        alt="{{ method.details.card.brand }}" />
                    <span class="card-number">•••• •••• •••• {{ method.details.card.last4 }}</span>
                </div>
                <div class="card-footer payment-footer">
                    <span>EXP {{ method.details.card.exp_month }}/{{ method.details.card.exp_year }}</span>
                    <button  mat-button color="warn" *ngIf="!authService.isImpersonating.value" (click)="deletecard(method)">Remove</button>
                </div>
            </mat-card>
        </div>

        <div class="payment-methods-item">
            <div class="add-payment-method" *ngIf="!loading">
                <a (click)="errorMassage ? showError() : paymentMethod()">
                    <mat-card class="add-card" *ngIf="!authService.isImpersonating.value">
                        <mat-icon class="add-icon">add_circle</mat-icon>
                        <p>Add New Card</p>
                    </mat-card>
                </a>
            </div>
        </div>
    </div>
</div>